import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import BrandLogo from "../brand/BrandLogo";
import Icon from "../brand/Icon";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  // Scroll to a section on the home page, navigating there first if needed.
  const goToSection = (id) => (e) => {
    e.preventDefault();
    const scroll = () => {
      const section = document.getElementById(id);
      if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    if (location.pathname === "/") {
      scroll();
    } else {
      navigate("/");
      setTimeout(scroll, 200);
    }
  };

  const year = new Date().getFullYear();

  return (
    <footer className="ts-footer">
      <div className="tf-container">
        <div className="ts-footer__grid">
          <div className="ts-footer__about">
            <Link to="/" aria-label="TalSolution home">
              <BrandLogo variant="dark" size={34} />
            </Link>
            <p>
              TalSolution connects skilled global professionals with vetted US opportunities. Always free for
              candidates.
            </p>
            <ul className="ts-footer__contact">
              <li>
                <Icon name="pin" size={18} />
                <span>2821 Mexico Gravel Rd #5, Columbia MO 65202</span>
              </li>
              <li>
                <Icon name="phone" size={18} />
                <a href="tel:+12108302282">+1 (210) 830-2282</a>
              </li>
              <li>
                <Icon name="mail" size={18} />
                <a href="mailto:info@talsolution.com">info@talsolution.com</a>
              </li>
            </ul>
          </div>

          <nav className="ts-footer__col" aria-label="Company">
            <h6>Company</h6>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/" onClick={goToSection("what-is-talsolution")}>About us</Link></li>
              <li><Link to="/" onClick={goToSection("how-it-works")}>How it works</Link></li>
              <li><Link to="/" onClick={goToSection("contact-section")}>Contact</Link></li>
            </ul>
          </nav>

          <nav className="ts-footer__col" aria-label="Candidates">
            <h6>For candidates</h6>
            <ul>
              <li><Link to="/careers">Browse open roles</Link></li>
              <li><Link to="/careers?search=Engineer">Engineering roles</Link></li>
              <li><Link to="/careers?search=Assistant">Virtual assistant roles</Link></li>
              <li><Link to="/register">Create a free profile</Link></li>
            </ul>
          </nav>

          <nav className="ts-footer__col" aria-label="Legal">
            <h6>Legal</h6>
            <ul>
              <li><Link to="/termsofuse">Terms of service</Link></li>
              <li><Link to="/privacypolicy">Privacy policy</Link></li>
              <li><Link to="/cookiepolicy">Cookie policy</Link></li>
            </ul>
          </nav>
        </div>

        <div className="ts-footer__bottom">
          <span>© {year} TalSolution. All rights reserved.</span>
          <span className="ts-footer__tagline">Global talent. US opportunities.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
